<script lang="ts">
    import WidgetTemplateEmpty from './WidgetTemplateEmpty.svelte';

    export let addWidget: () => void = () => {};
</script>

<WidgetTemplateEmpty {addWidget} />
